// Contact form - just prevent double submissions
// The form submits natively, reCAPTCHA and Craft handle the rest

document.querySelectorAll(".js-contact-form").forEach((form) => {
  form.addEventListener("submit", () => {
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = document.documentElement.lang === "en" ? "Sending..." : "Sender...";
    }
  });
});
